interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Polkadot = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26643)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#FB007B"
      />
      <path
        d="M50.188 32.6784C56.1453 32.6784 60.9747 29.8402 60.9747 26.3392C60.9747 22.8382 56.1453 20 50.188 20C44.2306 20 39.4013 22.8382 39.4013 26.3392C39.4013 29.8402 44.2306 32.6784 50.188 32.6784Z"
        fill="white"
      />
      <path
        d="M50.188 80C56.1453 80 60.9747 77.1618 60.9747 73.6608C60.9747 70.1598 56.1453 67.3216 50.188 67.3216C44.2306 67.3216 39.4013 70.1598 39.4013 73.6608C39.4013 77.1618 44.2306 80 50.188 80Z"
        fill="white"
      />
      <path
        d="M35.0928 71.1707C38.1248 69.4202 38.168 63.8187 35.1893 58.6595C32.2106 53.5003 27.338 50.737 24.3061 52.4876C21.2741 54.2381 21.2308 59.8395 24.2095 64.9987C27.1882 70.1579 32.0608 72.9212 35.0928 71.1707Z"
        fill="white"
      />
      <path
        d="M76.0707 47.5132C79.1027 45.7627 79.146 40.1612 76.1673 35.002C73.1886 29.8428 68.316 27.0795 65.284 28.8301C62.252 30.5806 62.2088 36.182 65.1875 41.3412C68.1661 46.5004 73.0388 49.2637 76.0707 47.5132Z"
        fill="white"
      />
      <path
        d="M76.3879 64.7667C79.3666 59.5838 79.3121 53.9631 76.2662 52.2126C73.2203 50.4621 68.3364 53.2446 65.3577 58.4275C62.3791 63.6104 62.4336 69.231 65.4795 70.9815C68.5254 72.732 73.4093 69.9496 76.3879 64.7667Z"
        fill="white"
      />
      <path
        d="M35.1858 41.3395C38.1645 36.1803 38.1213 30.5789 35.0893 28.8284C32.0573 27.0779 27.1847 29.8411 24.206 35.0003C21.2274 40.1595 21.2706 45.761 24.3026 47.5115C27.3346 49.262 32.2072 46.4987 35.1858 41.3395Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_26643">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
